import { Application, Feature } from '@frontend/functionality/types';
import { useAccountRepository } from '@frontend/repository';
import { FormattedMessage } from 'react-intl';

import { NivalizCoffinsAwaitingDropOff } from '../../../statistics/nivaliz/coffins-awaiting-drop-off/coffins-awaiting-drop-off.component';
import { NivalizCoffinsAwaitingPickUp } from '../../../statistics/nivaliz/coffins-awaiting-pick-up/coffins-awaiting-pick-up.component';
import { Last30DaysNivalizOutboundTransactionVolumeByStateListChart } from '../../../statistics/nivaliz/last-30-days-nivaliz-outbound-transaction-volume-by-state-list-chart/last-30-days-nivaliz-outbound-transaction-volume-by-state-list-chart.component';
import { Last30DaysNivalizTransactionVolumeLineChart } from '../../../statistics/nivaliz/last-30-days-nivaliz-transaction-volume-line-chart/last-30-days-nivaliz-transaction-volume-line-chart.component';
import { NivalizUrnsAwaitingDropOff } from '../../../statistics/nivaliz/urns-awaiting-drop-off/urns-awaiting-drop-off.component';
import { NivalizUrnsAwaitingPickUp } from '../../../statistics/nivaliz/urns-awaiting-pick-up/urns-awaiting-pick-up.component';
import { Last30DaysPudoSpotFillRateLineChart } from '../../../statistics/pudo/last-30-days-pudo-spot-fill-rate-line-chart/last-30-days-pudo-spot-fill-rate-line-chart.component';
import { Dashboard, DashboardCard } from '../../../statistics/shared';
import OverviewHeader from '../../header/overview-header';

const NivalizDashboard = () => {
    const { currentAccount } = useAccountRepository();

    return (
        <div
            key='nivaliz-dashboard'
            className='bg-background-default flex w-full flex-col items-start justify-start gap-6 self-stretch'>
            <OverviewHeader
                title={
                    <FormattedMessage
                        id='nivaliz-dashboard.title'
                        description='Page title of the Nivaliz application dashboard'
                        defaultMessage='Nivaliz / Dashboard'
                    />
                }
            />
            <Dashboard>
                <DashboardCard size='3x1.5'>
                    <Last30DaysNivalizTransactionVolumeLineChart
                        accountId={currentAccount}
                        navigateUrl='../transactions'
                    />
                </DashboardCard>
                <DashboardCard size='3x1.5'>
                    <Last30DaysPudoSpotFillRateLineChart
                        accountId={currentAccount}
                        application={Application.NIVALIZ}
                        feature={Feature.OUTBOUND_TRANSACTION}
                    />
                </DashboardCard>
                <DashboardCard size='3x1'>
                    <NivalizUrnsAwaitingDropOff
                        accountId={currentAccount}
                        navigateUrl='../urns?tab=awaiting_drop_off'
                    />
                </DashboardCard>
                <DashboardCard size='3x1'>
                    <NivalizCoffinsAwaitingDropOff
                        accountId={currentAccount}
                        navigateUrl='../coffins?tab=awaiting_drop_off'
                    />
                </DashboardCard>
                <DashboardCard size='3x1'>
                    <NivalizUrnsAwaitingPickUp
                        accountId={currentAccount}
                        navigateUrl='../urns?tab=awaiting_pick_up'
                    />
                </DashboardCard>
                <DashboardCard size='3x1'>
                    <NivalizCoffinsAwaitingPickUp
                        accountId={currentAccount}
                        navigateUrl='../coffins?tab=awaiting_pick_up'
                    />
                </DashboardCard>
                <DashboardCard size='2x2'>
                    <Last30DaysNivalizOutboundTransactionVolumeByStateListChart accountId={currentAccount} />
                </DashboardCard>
            </Dashboard>
        </div>
    );
};

export default NivalizDashboard;
